import { Component, Input, ViewChild, inject } from "@angular/core";
import { SeriesLineOptions } from "highcharts";

import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-rotor-vibe-chart",
	templateUrl: "./rotor-vibe-chart.component.html",
	styleUrls: ["./rotor-vibe-chart.component.scss"],
	imports: [DvsChartComponent]
})
export class RotorVibeChartComponent {
	private api = inject(ApiService);
	private charting = inject(ChartingService);

	@Input()
	public vshaft: VShaftWithPlot;
	@Input()
	public avgLabel = "Average";
	@Input()
	public predLabel = "Prediction";
	@Input()
	public disableDownload = false;

	@ViewChild("chart")
	private chartComponent: DvsChartComponent;

	DownloadData(vshaft: VShaftWithPlot) {
		let output = "regime,avgmag,avgphase,predmag,predphase\n";
		for (const series of vshaft.plotOptions.series as SeriesLineOptions[]) {
			console.log(series.data)
			const avg: any = series.data.find((item: any) => item.name === this.avgLabel);
			const pred: any = series.data.find((item: any) => item.name === this.predLabel);
			output += '"' + series.name + '",' + avg.y.toFixed(5) + "," + avg.x.toFixed(5) + "," + pred.y.toFixed(5) + "," + pred.x.toFixed(5) + "\n";
		}
		this.api.DownloadFile(vshaft.name + ".csv", output);
	}

	public UpdatePrediction(newPred: number[]) {
		if (this.chartComponent?.chart?.series?.length !== 1) return;
		const series = this.chartComponent.chart.series[0];
		const predPoint = series.data.find(point => point.name === this.predLabel);
		if (predPoint) {
			predPoint.update({ x: newPred[0], y: newPred[1] });
		}
	}

}

interface VShaftWithPlot extends APIResults.VShaft {
	plotOptions?: Highcharts.Options;
}
